import React from "react";
import PropTypes from "prop-types";

const DrugListDialog = props => {
  const { drugList, selectDrug } = props;
  return (
    drugList.length && (
      <div className="custom-dropdown-search-list-pin-popup-prescription custom-dropdown-search-list-prescription">
        <ul>
          {drugList.map((item, index) => {
            return (
              <li
                key={index}
                onClick={() => selectDrug(item)}
                style={{
                  pointerEvents:
                    item.productId === "ingredient" ||
                    item.productId === "brand"
                      ? "none"
                      : "auto"
                }}
              >
                <div className="item-container">
                  <span
                    className={
                      item.productId === "ingredient" ||
                      item.productId === "brand"
                        ? "drug-list__select-disable"
                        : item.productId === "manually_enter"
                        ? "drug-list__manually-enter"
                        : "drug-search-name"
                    }
                  >
                    {item.productName}
                  </span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    )
  );
};

export default DrugListDialog;

DrugListDialog.propTypes = {
  selectDrug: PropTypes.func,
  drugList: PropTypes.array
};
